import "./ResultsInformationCard.scss";
import { truncated } from "../CoordinateDisplay";

const ResultsInformationCard = (props) => {
  const { analyzeResult } = props;
  const precision = 2;

  const size = analyzeResult?.part?.hasOwnProperty('size') ? [
    truncated(analyzeResult?.part?.size[0], precision) || 0,
    truncated(analyzeResult?.part?.size[1], precision) || 0,
    truncated(analyzeResult?.part?.size[2], precision) || 0,
  ] : [0, 0, 0];

  const buildDir = analyzeResult?.part?.hasOwnProperty('build_dir') ? [
    analyzeResult?.part?.build_dir[0] || 0,
    analyzeResult?.part?.build_dir[1] || 0,
    analyzeResult?.part?.build_dir[2] || 0,
  ] : [0, 0, 0];

  const rotateAxis = analyzeResult?.part?.hasOwnProperty('rotate_axis') ? [
    analyzeResult?.part?.rotate_axis[0] || 0,
    analyzeResult?.part?.rotate_axis[1] || 0,
    analyzeResult?.part?.rotate_axis[2] || 0,
  ] : [0, 0, 0];

  const rotate = analyzeResult?.part?.hasOwnProperty('rotate') ? [
    truncated(analyzeResult?.part?.rotate[0], precision) || 0,
    truncated(analyzeResult?.part?.rotate[1], precision) || 0,
    truncated(analyzeResult?.part?.rotate[2], precision) || 0,
  ] : [0, 0, 0];

  const translate = analyzeResult?.part?.hasOwnProperty('translate') ? [
    truncated(analyzeResult?.part?.translate[0], precision) || 0,
    truncated(analyzeResult?.part?.translate[1], precision) || 0,
    truncated(analyzeResult?.part?.translate[2], precision) || 0,
  ] : [0, 0, 0];

  return (
    <>
      <div className="analysisResultLeftCard mt-3">
        <div className="container">
          <div className="row">
            <div className="label">Part Name</div>
            <div className="value">{props.partName}</div>
          </div>
          <div className="row">
            <div className="label">Dimensions</div>
            <div className="value">
              {size[0] + ", " + size[1] + ", " + size[2]}
            </div>
          </div>
          <div className="row">
            <div className="label">Category</div>
            <div className="value">Test Category 1</div>
          </div>
          <div className="volume">
            <div className="label">Volume</div>
            <div className="value">{analyzeResult?.part?.volume || 0}</div>
          </div>
        </div>
      </div>
      <div className="buildSliceSceneControls mt-3">
        <div className="container">
          <div className="header">General Part Level Information</div>
          <div className="row">
            <div className="item">
              <div className="label">Size</div>
              <div className="value">
                {size[0] + ", " + size[1] + ", " + size[2]}
              </div>
            </div>
            <div className="item">
              <div className="label second-column">Volume</div>
              <div className="value">{analyzeResult?.part?.volume || 0}</div>
            </div>
          </div>
          <div className="row">
            <div className="item">
              <div className="lable">Rotate</div>
              <div className="value">
                {rotate[0] + ", " + rotate[1] + ", " + rotate[2]}
              </div>
            </div>
            <div className="item">
              <div className="label second-column">Area</div>
              <div className="value">{analyzeResult?.part?.area || 0}</div>
            </div>
          </div>
          <div className="row">
            <div className="item">
              <div className="lable">Translate</div>
              <div className="value">
                {translate[0] + ", " + translate[1] + ", " + translate[2]}
              </div>
            </div>
            <div className="item">
              <div className="label second-column">Weight</div>
              <div className="value">{analyzeResult?.part?.weight || 0}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResultsInformationCard;
